/**
 * Returns an array of roles that require a change ticket.
 */
export const getChangeRequestExemptRoles = (): string[] => {
    return ['ReadOnly', "Security"];
};